import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { QRCodeComponent } from 'angularx-qrcode';
import { ToastrModule } from "ngx-toastr";
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MultiSelectModule } from "primeng/multiselect";
import { SelectModule } from 'primeng/select';
import { SkeletonModule } from "primeng/skeleton";
import { StepperModule } from 'primeng/stepper';
import { CustomTableReportEquipmentLogbookComponent } from "src/app/components/custom-table-report-equipment-logbook/custom-table-report-equipment-logbook.component";
import { CustomChipComponent } from "../components/custom-chip/custom-chips.component";
import { CustomAuditInfoComponent } from "../components/custom-components/custom-audit-info/custom-audit-info.component";
import { CustomAutocompleteComponent } from '../components/custom-components/custom-autocomplete/custom-autocomplete.component';
import { CustomButtonComponent } from "../components/custom-components/custom-button/custom-button.component";
import { CustomCheckboxComponent } from '../components/custom-components/custom-checkbox/custom-checkbox.component';
import { CustomDatepickerReportComponent } from "../components/custom-components/custom-datepicker-report/custom-datepicker-report.component";
import { CustomDatepickerComponent } from '../components/custom-components/custom-datepicker/custom-datepicker.component';
import { CustomDatetimePickerComponent } from "../components/custom-components/custom-datetime-picker/custom-datetime-picker.component";
import { CustomInputDecimalComponent } from '../components/custom-components/custom-input-decimal/custom-input-decimal.component';
import { CustomInputImageFileComponent } from "../components/custom-components/custom-input-file/custom-input-image-file.component";
import { CustomInputNumberComponent } from '../components/custom-components/custom-input-number/custom-input-number.component';
import { CustomInputPasswordComponent } from "../components/custom-components/custom-input-password/custom-input-password.component";
import { CustomInputTextComponent } from '../components/custom-components/custom-input-text/custom-input-text.component';
import { CustomInputgroupComponent } from "../components/custom-components/custom-inputgroup/custom-inputgroup.component";
import { CustomRadiobuttonComponent } from "../components/custom-components/custom-radiobutton/custom-radiobutton.component";
import { CustomSelectComponent } from '../components/custom-components/custom-select/custom-select.component';
import { CustomTagComponent } from "../components/custom-components/custom-tag/custom-tag.component";
import { CustomTextareaComponent } from '../components/custom-components/custom-textarea/custom-textarea.component';
import { CustomToggleSwitchComponent } from "../components/custom-components/custom-toggle-switch/custom-toggle-switch.component";
import { CustomIndicatorsComponent } from '../components/custom-indicators/custom-indicators.component';
import { CustomInitialConsecutiveComponent } from "../components/custom-initial-consecutive/custom-initial-consecutive.component";
import { CustomModalComponent } from "../components/custom-modal/custom-modal.component";
import { CustomProgressBarComponent } from '../components/custom-progress/custom-progress-bar/custom-progress-bar.component';
import { CustomTablePrintComponent } from "../components/custom-table-print/custom-table-print.component";
import { CustomTableReportGeneratedReceiptsComponent } from "../components/custom-table-report-generated-receipts/custom-table-report-generated-receipts.component";
import { CustomTableReportPaymentsByClientComponent } from "../components/custom-table-report-payments-by-client/custom-table-report-payments-by-client.component";
import { CustomTableReportComponent } from "../components/custom-table-report/custom-table-report.component";
import { CustomTableComponent } from '../components/custom-table/custom-table.component';
import { NavigationComponent } from "../components/navigation/navigation/navigation.component";
import { UserPipe } from "../pipes/authentication/user.pipe";
import { DynamicFormatPipe } from "../pipes/formats/dynamic-format.pipe";
import { FormatLabelPipe } from "../pipes/formats/format-label.pipe";
import { GroupInfoPipe } from "../pipes/formats/group-info.pipe";
import { MonthPipe } from "../pipes/month.pipe";
import { RegisterTransportInvoiceDetailComponent } from "./additional/transport-invoice-detail/register-transport-invoice-detail/register-transport-invoice-detail.component";
import { TransportInvoiceDetailComponent } from "./additional/transport-invoice-detail/transport-invoice-detail/transport-invoice-detail.component";
import { RegisterTransportInvoiceComponent } from "./additional/transport-invoice/register-transport-invoice/register-transport-invoice.component";
import { TransportInvoiceComponent } from "./additional/transport-invoice/transport-invoice/transport-invoice.component";
import { ArticleGenericComponent } from "./archive/article-generic/article-generic/article-generic.component";
import { RegisterArticleGenericComponent } from "./archive/article-generic/register-article-generic/register-article-generic.component";
import { ArticleComponent } from "./archive/article/article/article.component";
import { AttachImagesArticleComponent } from "./archive/article/attach-images-article/attach-images-article.component";
import { EquipmentLogbookComponent } from './archive/article/equipment-logbook/equipment-logbook.component';
import { ImportArticleComponent } from "./archive/article/import-article/import-article.component";
import { ImportEquipmentLogbookComponent } from "./archive/article/import-equipment-logbook/import-equipment-logbook.component";
import { MaintenanceStrategyImportComponent } from "./archive/article/maintenance-strategy-import/maintenance-strategy-import.component";
import { MaintenanceStrategyComponent } from "./archive/article/maintenance-strategy/maintenance-strategy.component";
import { PrintEquipmentLogbookSimpleComponent } from "./archive/article/print-equipment-logbook-simple/print-equipment-logbook-simple.component";
import { PrintEquipmentLogbookValuedComponent } from "./archive/article/print-equipment-logbook-valued/print-equipment-logbook-valued.component";
import { RegisterArticleComponent } from "./archive/article/register-article/register-article.component";
import { ClientComponent } from "./archive/client/client/client.component";
import { ImportClientComponent } from "./archive/client/import-client/import-client.component";
import { RegisterClientComponent } from "./archive/client/register-client/register-client.component";
import { UpdateDocumentClientComponent } from "./archive/client/update-document-client/update-document-client.component";
import { ConstructionSiteComponent } from "./archive/construction-site/construction-site/construction-site.component";
import { ImportConstructionSiteComponent } from "./archive/construction-site/import-construction-site/import-construction-site.component";
import { RegisterConstructionSiteComponent } from "./archive/construction-site/register-construction-site/register-construction-site.component";
import { ContactReferenceModalComponent } from "./archive/contact-reference-modal/contact-reference-modal.component";
import { CostCenterPriceComponent } from "./archive/cost-center-price/cost-center-price/cost-center-price.component";
import { ImportCostCenterPriceComponent } from "./archive/cost-center-price/import-cost-center-price/import-cost-center-price.component";
import { RegisterCostCenterPriceComponent } from "./archive/cost-center-price/register-cost-center-price/register-cost-center-price.component";
import { CostCenterComponent } from "./archive/cost-center/cost-center/cost-center.component";
import { ImportCostCenterComponent } from "./archive/cost-center/import-cost-center/import-cost-center.component";
import { RegisterCostCenterComponent } from "./archive/cost-center/register-cost-center/register-cost-center.component";
import { CurrencyExchangeComponent } from "./archive/currency-exchange/currency-exchange/currency-exchange.component";
import { RegisterCurrencyExchangeComponent } from "./archive/currency-exchange/register-currency-exchange/register-currency-exchange.component";
import { FamilyComponent } from "./archive/family/family/family.component";
import { ImportFamilyComponent } from "./archive/family/import-family/import-family.component";
import { RegisterFamilyComponent } from "./archive/family/register-family/register-family.component";
import { GroupComponent } from "./archive/group/group/group.component";
import { ImportGroupComponent } from "./archive/group/import-group/import-group.component";
import { RegisterGroupComponent } from "./archive/group/register-group/register-group.component";
import { ImportMechanicComponent } from "./archive/mechanic/import-mechanic/import-mechanic.component";
import { MechanicComponent } from "./archive/mechanic/mechanic/mechanic.component";
import { RegisterMechanicComponent } from "./archive/mechanic/register-mechanic/register-mechanic.component";
import { UpdateDocumentMechanicComponent } from "./archive/mechanic/update-document-mechanic/update-document-mechanic.component";
import { ImportPriceListAsComponent } from "./archive/price-list-detail/import-price-list-as/import-price-list-as.component";
import { PriceListDetailComponent } from "./archive/price-list-detail/price-list-detail/price-list-detail.component";
import { RegisterPriceListDetailComponent } from "./archive/price-list-detail/register-price-list-detail/register-price-list-detail.component";
import { ImportPriceListComponent } from "./archive/price-list/import-price-list/import-price-list.component";
import { PriceListComponent } from "./archive/price-list/price-list/price-list.component";
import { RegisterPriceListComponent } from "./archive/price-list/register-price-list/register-price-list.component";
import { ImportProviderComponent } from "./archive/provider/import-provider/import-provider.component";
import { ProviderComponent } from "./archive/provider/provider/provider.component";
import { RegisterProviderComponent } from "./archive/provider/register-provider/register-provider.component";
import { UpdateDocumentProviderComponent } from "./archive/provider/update-document-provider/update-document-provider.component";
import { ImportSellerComponent } from "./archive/seller/import-seller/import-seller.component";
import { RegisterSellerComponent } from "./archive/seller/register-seller/register-seller.component";
import { SellerComponent } from "./archive/seller/seller/seller.component";
import { UpdateDocumentSellerComponent } from "./archive/seller/update-document-seller/update-document-seller.component";
import { ImportStoreComponent } from "./archive/store/import-store/import-store.component";
import { RegisterStoreComponent } from "./archive/store/register-store/register-store.component";
import { StoreComponent } from "./archive/store/store/store.component";
import { ImportSubgroupComponent } from "./archive/subgroup/import-subgroup/import-subgroup.component";
import { RegisterSubgroupComponent } from "./archive/subgroup/register-subgroup/register-subgroup.component";
import { SubgroupComponent } from "./archive/subgroup/subgroup/subgroup.component";
import { ImportTransporterComponent } from "./archive/transporter/import-transporter/import-transporter.component";
import { RegisterTransporterComponent } from "./archive/transporter/register-transporter/register-transporter.component";
import { TransporterComponent } from "./archive/transporter/transporter/transporter.component";
import { UpdateDocumentTransporterComponent } from "./archive/transporter/update-document-transporter/update-document-transporter.component";
import { RegisterUnitComponent } from "./archive/unit/register-unit/register-unit.component";
import { UnitComponent } from "./archive/unit/unit/unit.component";
import { ImportVehicleComponent } from "./archive/vehicle/import-vehicle/import-vehicle.component";
import { RegisterVehicleComponent } from "./archive/vehicle/register-vehicle/register-vehicle.component";
import { VehicleComponent } from "./archive/vehicle/vehicle/vehicle.component";
import { ImportZoneComponent } from "./archive/zone/import-zone/import-zone.component";
import { RegisterZoneComponent } from "./archive/zone/register-zone/register-zone.component";
import { ZoneComponent } from "./archive/zone/zone/zone.component";
import { AuditComponent } from "./audit/audit/audit.component";
import { TransactionsComponent } from "./audit/transactions/transactions.component";
import { CostCenterUserComponent } from "./authentication/cost-center-user/cost-center-user.component";
import { PermissionsProfileUserComponent } from "./authentication/profile-user/permissions-profile-user/permissions-profile-user.component";
import { ProfileUserComponent } from "./authentication/profile-user/profile-user/profile-user.component";
import { RegisterProfileUserComponent } from "./authentication/profile-user/register-profile-user/register-profile-user.component";
import { PermissionsUserComponent } from "./authentication/users/permissions-user/permissions-user.component";
import { RegisterUsersComponent } from "./authentication/users/register-users/register-users.component";
import { UpdatePasswordUserComponent } from "./authentication/users/update-password-user/update-password-user.component";
import { UserComponent } from "./authentication/users/user/user.component";
import { MainComponent } from "./components/main/main.component";
import { FormatDetailComponent } from "./formats/format-detail/format-detail/format-detail.component";
import { RegisterFormatDetailComponent } from "./formats/format-detail/register-format-detail/register-format-detail.component";
import { FormatComponent } from "./formats/format/format/format.component";
import { PreviewFormatComponent } from "./formats/format/preview-format/preview-format.component";
import { RegisterFormatComponent } from "./formats/format/register-format/register-format.component";
import { CostAdjustmentDetailComponent } from "./inventory/cost-adjustment-detail/cost-adjustment-detail/cost-adjustment-detail.component";
import { RegisterCostAdjustmentDetailComponent } from "./inventory/cost-adjustment-detail/register-cost-adjustment-detail/register-cost-adjustment-detail.component";
import { CostAdjustmentComponent } from "./inventory/cost-adjustment/cost-adjustment/cost-adjustment.component";
import { PrintCostAdjustmentComponent } from "./inventory/cost-adjustment/print-cost-adjustment/print-cost-adjustment.component";
import { RegisterCostAdjustmentComponent } from "./inventory/cost-adjustment/register-cost-adjustment/register-cost-adjustment.component";
import { InventoryBalancesImportComponent } from "./inventory/inventory-balances-import/inventory-balances-import.component";
import { InventoryClassComponent } from "./inventory/inventory-class/inventory-class/inventory-class.component";
import { RegisterInventoryClassComponent } from "./inventory/inventory-class/register-inventory-class/register-inventory-class.component";
import { InventoryEntryDetailComponent } from "./inventory/inventory-entry-detail/inventory-entry-detail/inventory-entry-detail.component";
import { RegisterInventoryEntryDetailComponent } from "./inventory/inventory-entry-detail/register-inventory-entry-detail/register-inventory-entry-detail.component";
import { ImportInventoryEntryComponent } from "./inventory/inventory-entry/import-inventory-entry/import-inventory-entry.component";
import { InventoryEntryComponent } from "./inventory/inventory-entry/inventory-entry/inventory-entry.component";
import { PrintInventoryEntryComponent } from "./inventory/inventory-entry/print-inventory-entry/print-inventory-entry.component";
import { RegisterInventoryEntryComponent } from "./inventory/inventory-entry/register-inventory-entry/register-inventory-entry.component";
import { InventoryOutputDetailComponent } from "./inventory/inventory-output-detail/inventory-output-detail/inventory-output-detail.component";
import { RegisterInventoryOutputDetailComponent } from "./inventory/inventory-output-detail/register-inventory-output-detail/register-inventory-output-detail.component";
import { InventoryOutputComponent } from "./inventory/inventory-output/inventory-output/inventory-output.component";
import { PrintInventoryOutputComponent } from "./inventory/inventory-output/print-inventory-output/print-inventory-output.component";
import { RegisterInventoryOutputComponent } from "./inventory/inventory-output/register-inventory-output/register-inventory-output.component";
import { InventoryPeriodComponent } from "./inventory/inventory-period/inventory-period/inventory-period.component";
import { RegisterInventoryPeriodComponent } from "./inventory/inventory-period/register-inventory-period/register-inventory-period.component";
import { BranchAverageCostComponent } from "./inventory/inventory-report/branch-average-cost/branch-average-cost.component";
import { EntryShopComponent } from "./inventory/inventory-report/entry-shop/entry-shop.component";
import { KardexArticleComponent } from "./inventory/inventory-report/kardex-article/kardex-article.component";
import { OutputShopComponent } from "./inventory/inventory-report/output-shop/output-shop.component";
import { StockMaxComponent } from "./inventory/inventory-report/stock-max/stock-max.component";
import { StockMinComponent } from "./inventory/inventory-report/stock-min/stock-min.component";
import { SummaryInventoryMovementComponent } from "./inventory/inventory-report/summary-inventory-movement/summary-inventory-movement.component";
import { TypeQuantitiesComponent } from "./inventory/inventory-report/type-quantities/type-quantities.component";
import { TypeSummaryValuesComponent } from "./inventory/inventory-report/type-summary-values/type-summary-values.component";
import { TypeDetailedValuesComponent } from "./inventory/inventory-report/type_detailed_values/type_detailed_values.component";
import { InventoryTransferDetailComponent } from "./inventory/inventory-transfer-detail/inventory-transfer-detail/inventory-transfer-detail.component";
import { RegisterInventoryTransferDetailComponent } from "./inventory/inventory-transfer-detail/register-inventory-transfer-detail/register-inventory-transfer-detail.component";
import { InventoryTransferComponent } from "./inventory/inventory-transfer/inventory-transfer/inventory-transfer.component";
import { PrintInventoryTransferComponent } from "./inventory/inventory-transfer/print-inventory-transfer/print-inventory-transfer.component";
import { RegisterInventoryTransferComponent } from "./inventory/inventory-transfer/register-inventory-transfer/register-inventory-transfer.component";
import { InventoryUserComponent } from "./inventory/inventory-user/inventory-user.component";
import { InventoryComponent } from "./inventory/inventory/inventory/inventory.component";
import { RegisterInventoryComponent } from "./inventory/inventory/register-inventory/register-inventory.component";
import { PhysicalInventoryDetailComponent } from "./inventory/physical-inventory-detail/physical-inventory-detail/physical-inventory-detail.component";
import { RegisterPhysicalInventoryDetailComponent } from "./inventory/physical-inventory-detail/register-physical-inventory-detail/register-physical-inventory-detail.component";
import { PhysicalInventoryReportComponent } from "./inventory/physical-inventory-report/physical-inventory-report.component";
import { AdjustExcessModalComponent } from "./inventory/physical-inventory/adjust-excess-modal/adjust-excess-modal.component";
import { PhysicalInventoryComponent } from "./inventory/physical-inventory/physical-inventory/physical-inventory.component";
import { RegisterPhysicalInventoryComponent } from "./inventory/physical-inventory/register-physical-inventory/register-physical-inventory.component";
import { ReverseInventoryBalancesComponent } from "./inventory/reverse-inventory-balances/reverse-inventory-balances.component";
import { RegisterSalesRemissionDetailComponent } from "./inventory/sales-remission-detail/register-sales-remission-detail/register-sales-remission-detail.component";
import { SalesRemissionDetailComponent } from "./inventory/sales-remission-detail/sales-remission-detail/sales-remission-detail.component";
import { SalesRemissionManualOrderComponent } from "./inventory/sales-remission-detail/sales-remission-manual-order/sales-remission-manual-order.component";
import { SalesRemissionMassiveOrderComponent } from "./inventory/sales-remission-detail/sales-remission-massive-order/sales-remission-massive-order.component";
import { PrintSalesRemissionComponent } from "./inventory/sales-remission/print-sales-remission/print-sales-remission.component";
import { RegisterSalesRemissionComponent } from "./inventory/sales-remission/register-sales-remission/register-sales-remission.component";
import { SalesRemissionComponent } from "./inventory/sales-remission/sales-remission/sales-remission.component";
import { ImportStockMaxMinComponent } from "./inventory/stock-max-min/import-stock-max-min/import-stock-max-min.component";
import { RegisterStockMaxMinComponent } from "./inventory/stock-max-min/register-stock-max-min/register-stock-max-min.component";
import { StockMaxMinComponent } from "./inventory/stock-max-min/stock-max-min/stock-max-min.component";
import { RegisterTypeInventoryComponent } from "./inventory/type-inventory/register-type-inventory/register-type-inventory.component";
import { TypeInventoryComponent } from "./inventory/type-inventory/type-inventory/type-inventory.component";
import { AccountingInterfaceDetailComponent } from "./invoicing/accounting-interface-detail/accounting-interface-detail/accounting-interface-detail.component";
import { AccountingInterfacePreviewComponent } from "./invoicing/accounting-interface-detail/accounting-interface-preview/accounting-interface-preview.component";
import { SynchronizerAccountingInterfaceComponent } from "./invoicing/accounting-interface-detail/synchronizer-accounting-interface/synchronizer-accounting-interface.component";
import { AccountingInterfaceComponent } from "./invoicing/accounting-interface/accounting-interface/accounting-interface.component";
import { RegisterAccountingInterfaceComponent } from "./invoicing/accounting-interface/register-accounting-interface/register-accounting-interface.component";
import { AdvanceInvoiceConceptComponent } from "./invoicing/advance-invoice-concept/advance-invoice-concept/advance-invoice-concept.component";
import { RegisterAdvanceInvoiceConceptComponent } from "./invoicing/advance-invoice-concept/register-advance-invoice-concept/register-advance-invoice-concept.component";
import { AdvanceInvoiceComponent } from "./invoicing/advance-invoice/advance-invoice/advance-invoice.component";
import { RegisterAdvanceInvoiceComponent } from "./invoicing/advance-invoice/register-advance-invoice/register-advance-invoice.component";
import { ConceptInvoicingComponent } from "./invoicing/concept-invoicing/concept-invoicing/concept-invoicing.component";
import { ImportConceptInvoicingComponent } from "./invoicing/concept-invoicing/import-concept-invoicing/import-concept-invoicing.component";
import { RegisterConceptInvoicingComponent } from "./invoicing/concept-invoicing/register-concept-invoicing/register-concept-invoicing.component";
import { ElectronicInvoiceInterfaceDetailComponent } from "./invoicing/electronic-invoice-interface-detail/electronic-invoice-interface-detail/electronic-invoice-interface-detail.component";
import { ElectronicInvoiceInterfaceComponent } from "./invoicing/electronic-invoice-interface/electronic-invoice-interface/electronic-invoice-interface.component";
import { RegisterElectronicInvoiceInterfaceComponent } from "./invoicing/electronic-invoice-interface/register-electronic-invoice-interface/register-electronic-invoice-interface.component";
import { SendMailComponent } from "./invoicing/electronic-invoice-interface/send-mail/send-mail.component";
import { SynchronizerElectronicInvoiceInterfaceComponent } from "./invoicing/electronic-invoice-interface/synchronizer-electronic-invoice-interface/synchronizer-electronic-invoice-interface.component";
import { ListInvoiceConceptComponent } from "./invoicing/invoice-concept/list-invoice-concept/list-invoice-concept.component";
import { InvoiceDetailComponent } from "./invoicing/invoice-detail/invoice-detail/invoice-detail.component";
import { RegisterInvoiceDetailComponent } from "./invoicing/invoice-detail/register-invoice-detail/register-invoice-detail.component";
import { CopyInvoiceComponent } from "./invoicing/invoice/copy-invoice/copy-invoice.component";
import { InfoInvoiceComponent } from "./invoicing/invoice/info-invoice/info-invoice.component";
import { InvoicePrintingRangeComponent } from "./invoicing/invoice/invoice-printing-range/invoice-printing-range.component";
import { InvoiceComponent } from "./invoicing/invoice/invoice/invoice.component";
import { InvoicesImportComponent } from "./invoicing/invoice/invoices-import/invoices-import.component";
import { ListInvoiceAttachmentsComponent } from "./invoicing/invoice/list-invoice-attachments/list-invoice-attachments.component";
import { PrintInvoiceComponent } from "./invoicing/invoice/print-invoice/print-invoice.component";
import { RegisterInvoiceComponent } from "./invoicing/invoice/register-invoice/register-invoice.component";
import { SettlementComponent } from "./invoicing/invoice/settlement/settlement.component";
import { InvoicingCutoffDetailComponent } from "./invoicing/invoicing-cutoff-detail/invoicing-cutoff-detail/invoicing-cutoff-detail.component";
import { InvoiceInvoicingCutoffComponent } from "./invoicing/invoicing-cutoff/invoice-invoicing-cutoff/invoice-invoicing-cutoff.component";
import { InvoicingCutoffComponent } from "./invoicing/invoicing-cutoff/invoicing-cutoff/invoicing-cutoff.component";
import { RegisterInvoicingCutoffComponent } from "./invoicing/invoicing-cutoff/register-invoicing-cutoff/register-invoicing-cutoff.component";
import { CopyInvoicingModelComponent } from "./invoicing/invoicing-model-detail/copy-invoicing-model/copy-invoicing-model.component";
import { ImportInvoicingModelDetailComponent } from "./invoicing/invoicing-model-detail/import-invoicing-model-detail/import-invoicing-model-detail.component";
import { InvoicingModelDetailComponent } from "./invoicing/invoicing-model-detail/invoicing-model-detail/invoicing-model-detail.component";
import { RegisterInvoicingModelDetailComponent } from "./invoicing/invoicing-model-detail/register-invoicing-model-detail/register-invoicing-model-detail.component";
import { InvoicingModelComponent } from "./invoicing/invoicing-model/invoicing-model/invoicing-model.component";
import { RegisterInvoicingModelComponent } from "./invoicing/invoicing-model/register-invoicing-model/register-invoicing-model.component";
import { BalancesCostCenterComponent } from "./invoicing/invoicing-report/balances-cost-center/balances-cost-center.component";
import { DailyReportVoucherComponent } from "./invoicing/invoicing-report/daily-report-voucher/daily-report-voucher.component";
import { DiscountsLowerHundredPercentComponent } from "./invoicing/invoicing-report/discounts-lower-hundred-percent/discounts-lower-hundred-percent.component";
import { DiscountsTopThirtyPercentComponent } from "./invoicing/invoicing-report/discounts-top-thirty-percent/discounts-top-thirty-percent.component";
import { IncomeCostcenterEquipmentComponent } from "./invoicing/invoicing-report/income-costcenter-equipment/income-costcenter-equipment.component";
import { IncomeReportComponent } from "./invoicing/invoicing-report/income-report/income-report.component";
import { InvoicesByConceptComponent } from "./invoicing/invoicing-report/invoices-by-concept/invoices-by-concept.component";
import { InvoicesGeneratedComponent } from "./invoicing/invoicing-report/invoices-generated/invoices-generated.component";
import { InvoicingAddressReportComponent } from "./invoicing/invoicing-report/invoicing-address-report/invoicing-address-report.component";
import { InvoicingBusinessTypeComponent } from "./invoicing/invoicing-report/invoicing-business-type/invoicing-business-type.component";
import { InvoicingClientConstructionSiteComponent } from "./invoicing/invoicing-report/invoicing-client-construction-site/invoicing-client-construction-site.component";
import { InvoicingClientCostCenterGroupComponent } from "./invoicing/invoicing-report/invoicing-client-cost-center-group/invoicing-client-cost-center-group.component";
import { InvoicingClientComponent } from "./invoicing/invoicing-report/invoicing-client/invoicing-client.component";
import { InvoicingConceptSellerComponent } from "./invoicing/invoicing-report/invoicing-concept-seller/invoicing-concept-seller.component";
import { InvoicingConceptComponent } from "./invoicing/invoicing-report/invoicing-concept/invoicing-concept.component";
import { InvoicingCostCenterComponent } from "./invoicing/invoicing-report/invoicing-cost-center/invoicing-cost-center.component";
import { InvoicingFamilyComponent } from './invoicing/invoicing-report/invoicing-family/invoicing-family.component';
import { InvoicingKilogramsComponent } from "./invoicing/invoicing-report/invoicing-kilograms/invoicing-kilograms.component";
import { InvoicingSellerConceptComponent } from './invoicing/invoicing-report/invoicing-seller-concept/invoicing-seller-concept.component';
import { InvoicingSellerKilogramsComponent } from "./invoicing/invoicing-report/invoicing-seller-kilograms/invoicing-seller-kilograms.component";
import { ItemRevenueStoreComponent } from "./invoicing/invoicing-report/item-revenue-store/item-revenue-store.component";
import { ItemRevenueComponent } from "./invoicing/invoicing-report/item-revenue/item-revenue.component";
import { PendingInvoiceComponent } from "./invoicing/invoicing-report/pending-invoice/pending-invoice.component";
import { PreInvoicingItemRevenueComponent } from "./invoicing/invoicing-report/pre-invoicing-item-revenue/pre-invoicing-item-revenue.component";
import { TaxReportComponent } from "./invoicing/invoicing-report/tax-report/tax-report.component";
import { TotalMonthComponent } from "./invoicing/invoicing-report/total-month/total-month.component";
import { NoteDetailComponent } from "./invoicing/note-detail/note-detail/note-detail.component";
import { RegisterNoteDetailArticleComponent } from "./invoicing/note-detail/register-note-detail-article/register-note-detail-article.component";
import { RegisterNoteDetailConceptComponent } from "./invoicing/note-detail/register-note-detail-concept/register-note-detail-concept.component";
import { NoteComponent } from "./invoicing/note/note/note.component";
import { NotesImportComponent } from "./invoicing/note/notes-import/notes-import.component";
import { PrintNoteComponent } from "./invoicing/note/print-note/print-note.component";
import { RegisterNoteComponent } from "./invoicing/note/register-note/register-note.component";
import { PreInvoiceComponent } from "./invoicing/pre-invoicing/pre-invoice/pre-invoice.component";
import { PreInvoicingComponent } from "./invoicing/pre-invoicing/pre-invoicing/pre-invoicing.component";
import { PreviewPreInvoicingComponent } from "./invoicing/pre-invoicing/preview-pre-invoicing/preview-pre-invoicing.component";
import { RequestNoteDetailComponent } from "./invoicing/request-note-detail/request-note-detail/request-note-detail.component";
import { PrintRequestNoteComponent } from "./invoicing/request-note/print-request-note/print-request-note.component";
import { RegisterRequestNoteComponent } from "./invoicing/request-note/register-request-note/register-request-note.component";
import { RequestNoteComponent } from "./invoicing/request-note/request-note/request-note.component";
import { ComponentComponent } from "./maintenance/component/component/component.component";
import { RegisterComponentComponent } from "./maintenance/component/register-component/register-component.component";
import { ElementComponent } from "./maintenance/element/element/element.component";
import { RegisterElementComponent } from "./maintenance/element/register-element/register-element.component";
import { ImportMaintenanceActivitiesComponent } from "./maintenance/maintenance-activities/import-maintenance-activities/import-maintenance-activities.component";
import { MaintenanceActivitiesComponent } from "./maintenance/maintenance-activities/maintenance-activities/maintenance-activities.component";
import { RegisterMaintenanceActivitiesComponent } from "./maintenance/maintenance-activities/register-maintenance-activities/register-maintenance-activities.component";
import { MaintenanceOrderActivitiesComponent } from "./maintenance/maintenance-order-activities/maintenance-order-activities/maintenance-order-activities.component";
import { MaintenanceOrderSuppliesComponent } from "./maintenance/maintenance-order-supplies/maintenance-order-supplies/maintenance-order-supplies.component";
import { RegisterMaintenanceOrderSuppliesComponent } from "./maintenance/maintenance-order-supplies/register-maintenance-order-supplies/register-maintenance-order-supplies.component";
import { MaintenanceOrderImportComponent } from "./maintenance/maintenance-order/maintenance-order-import/maintenance-order-import.component";
import { MaintenanceOrderComponent } from './maintenance/maintenance-order/maintenance-order/maintenance-order.component';
import { NoteStageModalComponent } from "./maintenance/maintenance-order/note-stage-modal/note-stage-modal.component";
import { PrintMaintenanceOrderScheduledComponent } from "./maintenance/maintenance-order/print-maintenance-order-scheduled/print-maintenance-order-scheduled.component";
import { PrintMaintenanceOrderSiteComponent } from "./maintenance/maintenance-order/print-maintenance-order-site/print-maintenance-order-site.component";
import { PrintMaintenanceOrderWorkshopComponent } from "./maintenance/maintenance-order/print-maintenance-order-workshop/print-maintenance-order-workshop.component";
import { RegisterMaintenanceOrderComponent } from "./maintenance/maintenance-order/register-maintenance-order/register-maintenance-order.component";
import { EquipmentLogbookReportComponent } from "./maintenance/maintenance-report/equipment-logbook-report/equipment-logbook-report.component";
import { MaintenanceCostsForEquipmentComponent } from "./maintenance/maintenance-report/maintenance-costs-for-equipment/maintenance-costs-for-equipment.component";
import { ProgrammingDaysComponent } from "./maintenance/maintenance-report/programming-days/programming-days.component";
import { RepairHistoryComponent } from "./maintenance/maintenance-report/repair-history/repair-history.component";
import { MaintenanceRoutineDetailComponent } from "./maintenance/maintenance-routine-detail/maintenance-routine-detail/maintenance-routine-detail.component";
import { RegisterMaintenanceRoutineDetailComponent } from "./maintenance/maintenance-routine-detail/register-maintenance-routine-detail/register-maintenance-routine-detail.component";
import { MaintenanceRoutineSupplyImportComponent } from "./maintenance/maintenance-routine-supply/maintenance-routine-supply-import/maintenance-routine-supply-import.component";
import { MaintenanceRoutineSupplyComponent } from "./maintenance/maintenance-routine-supply/maintenance-routine-supply/maintenance-routine-supply.component";
import { RegisterMaintenanceRoutineSupplyComponent } from "./maintenance/maintenance-routine-supply/register-maintenance-routine-supply/register-maintenance-routine-supply.component";
import { CopyMaintenanceRoutineComponent } from "./maintenance/maintenance-routine/copy-maintenance-routine/copy-maintenance-routine.component";
import { MaintenanceRoutineImportComponent } from "./maintenance/maintenance-routine/maintenance-routine-import/maintenance-routine-import.component";
import { MaintenanceRoutineComponent } from "./maintenance/maintenance-routine/maintenance-routine/maintenance-routine.component";
import { PrintMaintenanceRoutineComponent } from "./maintenance/maintenance-routine/print-maintenance-routine/print-maintenance-routine.component";
import { RegisterMaintenanceRoutineComponent } from "./maintenance/maintenance-routine/register-maintenance-routine/register-maintenance-routine.component";
import { GenerateMaintenanceOrdersComponent } from "./maintenance/maintenance-scheduling-detail/generate-maintenance-orders/generate-maintenance-orders.component";
import { MaintenanceSchedulingDetailComponent } from "./maintenance/maintenance-scheduling-detail/maintenance-scheduling-detail/maintenance-scheduling-detail.component";
import { ProcessMaintenanceSchedulingComponent } from "./maintenance/maintenance-scheduling-detail/process-maintenance-scheduling/process-maintenance-scheduling.component";
import { MaintenanceSchedulingComponent } from "./maintenance/maintenance-scheduling/maintenance-scheduling/maintenance-scheduling.component";
import { RegisterMaintenanceSchedulingComponent } from "./maintenance/maintenance-scheduling/register-maintenance-scheduling/register-maintenance-scheduling.component";
import { MeterDetailComponent } from "./maintenance/meter-detail/meter-detail/meter-detail.component";
import { RegisterMeterDetailComponent } from "./maintenance/meter-detail/register-meter-detail/register-meter-detail.component";
import { MeterComponent } from "./maintenance/meter/meter/meter.component";
import { RegisterMeterComponent } from "./maintenance/meter/register-meter/register-meter.component";
import { RepairImportComponent } from "./maintenance/repair/repair-import/repair-import.component";
import { RepairModalComponent } from "./maintenance/repair/repair-modal/repair-modal.component";
import { RepairComponent } from "./maintenance/repair/repair/repair.component";
import { StoreBalancesImportComponent } from "./maintenance/store-balances-import/store-balances-import.component";
import { ImportTransferStoreWorkshopDetailComponent } from "./maintenance/transfer-store-workshop-detail/import-transfer-store-workshop-detail/import-transfer-store-workshop-detail.component";
import { RegisterTransferStoreWorkshopDetailComponent } from "./maintenance/transfer-store-workshop-detail/register-transfer-store-workshop-detail/register-transfer-store-workshop-detail.component";
import { TransferStoreWorkshopDetailComponent } from "./maintenance/transfer-store-workshop-detail/transfer-store-workshop-detail/transfer-store-workshop-detail.component";
import { PrintTransferStoreWorkshopComponent } from "./maintenance/transfer-store-workshop/print-transfer-store-workshop/print-transfer-store-workshop.component";
import { RegisterTransferStoreWorkshopComponent } from "./maintenance/transfer-store-workshop/register-transfer-store-workshop/register-transfer-store-workshop.component";
import { TransferStoreWorkshopComponent } from "./maintenance/transfer-store-workshop/transfer-store-workshop/transfer-store-workshop.component";
import { RegisterTransferWorkshopStoreDetailComponent } from "./maintenance/transfer-workshop-store-detail/register-transfer-workshop-store-detail/register-transfer-workshop-store-detail.component";
import { TransferWorkshopStoreDetailComponent } from "./maintenance/transfer-workshop-store-detail/transfer-workshop-store-detail/transfer-workshop-store-detail.component";
import { PrintTransferWorkshopStoreComponent } from "./maintenance/transfer-workshop-store/print-transfer-workshop-store/print-transfer-workshop-store.component";
import { RegisterTransferWorkshopStoreComponent } from "./maintenance/transfer-workshop-store/register-transfer-workshop-store/register-transfer-workshop-store.component";
import { TransferWorkshopStoreComponent } from "./maintenance/transfer-workshop-store/transfer-workshop-store/transfer-workshop-store.component";
import { ListWorkshopEquipmentComponent } from "./maintenance/workshop-equipment/list-workshop-equipment/list-workshop-equipment.component";
import { AccountingModelDetailComponent } from "./management/accounting-model-detail/accounting-model-detail/accounting-model-detail.component";
import { RegisterAccountingModelDetailComponent } from "./management/accounting-model-detail/register-accounting-model-detail/register-accounting-model-detail.component";
import { AccountingModelComponent } from "./management/accounting-model/accounting-model/accounting-model.component";
import { AssignFamiliesComponent } from "./management/accounting-model/assign-families/assign-families.component";
import { ConceptFamilyForAccountingModelComponent } from "./management/accounting-model/concept-family-for-accounting-model/concept-family-for-accounting-model.component";
import { ConceptInvoicingForAccountingModelComponent } from "./management/accounting-model/concept-invoicing-for-accounting-model/concept-invoicing-for-accounting-model.component";
import { RegisterAccountingModelComponent } from "./management/accounting-model/register-accounting-model/register-accounting-model.component";
import { AdvancedOptionsBranchComponent } from "./management/branch/advanced-options-branch/advanced-options-branch.component";
import { BranchComponent } from "./management/branch/branch/branch.component";
import { RegisterBranchComponent } from "./management/branch/register-branch/register-branch.component";
import { BussinessDocumentsResolutionComponent } from "./management/bussiness-documents-resolution/bussiness-documents-resolution/bussiness-documents-resolution.component";
import { RegisterBussinessDocumentsResolutionComponent } from "./management/bussiness-documents-resolution/register-bussiness-documents-resolution/register-bussiness-documents-resolution.component";
import { BussinessDocumentsTypeComponent } from "./management/bussiness-documents-type/bussiness-documents-type/bussiness-documents-type.component";
import { RegisterBussinessDocumentsTypeComponent } from "./management/bussiness-documents-type/register-bussiness-documents-type/register-bussiness-documents-type.component";
import { CityComponent } from "./management/city/city/city.component";
import { RegisterCityComponent } from "./management/city/register-city/register-city.component";
import { CompanyCityComponent } from "./management/company-city/company-city/company-city.component";
import { RegisterCompanyCityComponent } from "./management/company-city/register-company-city/register-company-city.component";
import { AdvancedOptionsCompanyComponent } from "./management/company/advanced-options-company/advanced-options-company.component";
import { CompanyComponent } from "./management/company/company/company.component";
import { DeleteCompanyComponent } from "./management/company/delete-company/delete-company.component";
import { GeneralParameterComponent } from "./management/company/general-parameter/general-parameter.component";
import { MandatorComponent } from "./management/company/mandator/mandator.component";
import { PermissionsCompanyComponent } from "./management/company/permissions-company/permissions-company.component";
import { RegisterCompanyComponent } from "./management/company/register-company/register-company.component";
import { ConceptComponent } from "./management/concept/concept/concept.component";
import { RegisterConceptComponent } from "./management/concept/register-concept/register-concept.component";
import { CurrencyComponent } from "./management/currency/currency/currency.component";
import { RegisterCurrencyComponent } from "./management/currency/register-currency/register-currency.component";
import { DepartmentComponent } from "./management/department/department/department.component";
import { RegisterDepartmentComponent } from "./management/department/register-department/register-department.component";
import { EnterpriseCityComponent } from "./management/enterprise-city/enterprise-city/enterprise-city.component";
import { RegisterEnterpriseCityComponent } from "./management/enterprise-city/register-enterprise-city/register-enterprise-city.component";
import { AdvancedOptionsEnterpriseComponent } from "./management/enterprise/advanced-options-enterprise/advanced-options-enterprise.component";
import { AttachImagesEnterpriseComponent } from "./management/enterprise/attach-images-enterprise/attach-images-enterprise.component";
import { EnterpriseComponent } from "./management/enterprise/enterprise/enterprise.component";
import { RegisterEnterpriseComponent } from "./management/enterprise/register-enterprise/register-enterprise.component";
import { FreightModalComponent } from "./management/freight/freight-modal/freight-modal.component";
import { FreightComponent } from "./management/freight/freight/freight.component";
import { RegisterFreightComponent } from "./management/freight/register-freight/register-freight.component";
import { IcaRateComponent } from "./management/ica-rate/ica-rate/ica-rate.component";
import { ImportIcaRateComponent } from "./management/ica-rate/import-ica-rate/import-ica-rate.component";
import { RegisterIcaRateComponent } from "./management/ica-rate/register-ica-rate/register-ica-rate.component";
import { RegisterSectorComponent } from "./management/sector/register-sector/register-sector.component";
import { SectorComponent } from "./management/sector/sector/sector.component";
import { RegisterTaxTypeComponent } from "./management/tax-type/register-tax-type/register-tax-type.component";
import { TaxTypeComponent } from "./management/tax-type/tax-type/tax-type.component";
import { ImportTaxComponent } from "./management/tax/import-tax/import-tax.component";
import { RegisterTaxComponent } from "./management/tax/register-tax/register-tax.component";
import { TaxComponent } from "./management/tax/tax/tax.component";
import { RegisterTypeConceptComponent } from "./management/type-concept/register-type-concept/register-type-concept.component";
import { TypeConceptComponent } from "./management/type-concept/type-concept/type-concept.component";
import { RegisterWayToPayComponent } from "./management/way-to-pay/register-way-to-pay/register-way-to-pay.component";
import { WayToPayComponent } from "./management/way-to-pay/way-to-pay/way-to-pay.component";
import { ArticleTaskComponent } from "./others/article-task/article-task/article-task.component";
import { PendingArticleTaskComponent } from "./others/article-task/pending-article-task/pending-article-task.component";
import { RegisterArticleTaskComponent } from "./others/article-task/register-article-task/register-article-task.component";
import { ListChargeAccountConceptComponent } from "./others/charge-account-concept/list-charge-account-concept/list-charge-account-concept.component";
import { ChargeAccountDetailComponent } from "./others/charge-account-detail/charge-account-detail/charge-account-detail.component";
import { RegisterChargeAccountDetailComponent } from "./others/charge-account-detail/register-charge-account-detail/register-charge-account-detail.component";
import { AnnulChargeAccountComponent } from "./others/charge-account/annul-charge-account/annul-charge-account.component";
import { ChargeAccountPrintingRangeComponent } from "./others/charge-account/charge-account-printing-range/charge-account-printing-range.component";
import { ChargeAccountComponent } from "./others/charge-account/charge-account/charge-account.component";
import { CopyChargeAccountComponent } from "./others/charge-account/copy-charge-account/copy-charge-account.component";
import { PrintChargeAccountComponent } from "./others/charge-account/print-charge-account/print-charge-account.component";
import { RegisterChargeAccountComponent } from "./others/charge-account/register-charge-account/register-charge-account.component";
import { UpdateCostCenterPriceDetailComponent } from "./others/update-cost-center-price-detail/update-cost-center-price-detail/update-cost-center-price-detail.component";
import { RegisterUpdateCostCenterPriceComponent } from "./others/update-cost-center-price/register-update-cost-center-price/register-update-cost-center-price.component";
import { ApplyDiscountBreakdownComponent } from "./preliminaries/breakdown/apply-discount-breakdown/apply-discount-breakdown.component";
import { BreakdownComponent } from "./preliminaries/breakdown/breakdown/breakdown.component";
import { DistributeTotalValueBreakdownComponent } from "./preliminaries/breakdown/distribute-total-value-breakdown/distribute-total-value-breakdown.component";
import { ImportBreakdownComponent } from "./preliminaries/breakdown/import-breakdown/import-breakdown.component";
import { RegisterBreakdownComponent } from "./preliminaries/breakdown/register-breakdown/register-breakdown.component";
import { CompositeArticleDetailComponent } from "./preliminaries/composite-article-detail/composite-article-detail/composite-article-detail.component";
import { RegisterCompositeArticleDetailComponent } from "./preliminaries/composite-article-detail/register-composite-article-detail/register-composite-article-detail.component";
import { CompositeArticleComponent } from "./preliminaries/composite-article/composite-article/composite-article.component";
import { ImportCompositeArticleComponent } from "./preliminaries/composite-article/import-composite-article/import-composite-article.component";
import { RegisterCompositeArticleComponent } from "./preliminaries/composite-article/register-composite-article/register-composite-article.component";
import { ConsolidatedAvailabilityReportComponent } from "./preliminaries/consolidated-equipment-availability/consolidated-availability-report/consolidated-availability-report.component";
import { ConsolidatedEquipmentAvailabilityComponent } from "./preliminaries/consolidated-equipment-availability/consolidated-equipment-availability/consolidated-equipment-availability.component";
import { ConsolidatedReservationComponent } from "./preliminaries/consolidated-reservation/consolidated-reservation/consolidated-reservation.component";
import { DevolutionProjectionDetailComponent } from "./preliminaries/devolution-projection-detail/devolution-projection-detail/devolution-projection-detail.component";
import { RegisterDevolutionProjectionDetailComponent } from "./preliminaries/devolution-projection-detail/register-devolution-projection-detail/register-devolution-projection-detail.component";
import { DevolutionProjectionComponent } from "./preliminaries/devolution-projection/devolution-projection/devolution-projection.component";
import { RegisterDevolutionProjectionComponent } from "./preliminaries/devolution-projection/register-devolution-projection/register-devolution-projection.component";
import { EquipmentAvailabilityComponent } from "./preliminaries/equipment-availability/equipment-availability/equipment-availability.component";
import { CancelExecutedVisitComponent } from "./preliminaries/executed-visit/cancel-executed-visit/cancel-executed-visit.component";
import { ExecutedVisitComponent } from "./preliminaries/executed-visit/executed-visit/executed-visit.component";
import { PendingExecutedVisitComponent } from "./preliminaries/executed-visit/pending-executed-visit/pending-executed-visit.component";
import { RegisterExecutedVisitComponent } from "./preliminaries/executed-visit/register-executed-visit/register-executed-visit.component";
import { ImportMasterSolutionDetailComponent } from "./preliminaries/master-solution-detail/import-master-solution-detail/import-master-solution-detail.component";
import { MasterSolutionDetailComponent } from "./preliminaries/master-solution-detail/master-solution-detail/master-solution-detail.component";
import { RegisterMasterSolutionDetailComponent } from "./preliminaries/master-solution-detail/register-master-solution-detail/register-master-solution-detail.component";
import { MasterSolutionComponent } from "./preliminaries/master-solution/master-solution/master-solution.component";
import { RegisterMasterSolutionComponent } from "./preliminaries/master-solution/register-master-solution/register-master-solution.component";
import { ImportOrderDetailComponent } from "./preliminaries/order-detail/import-order-detail/import-order-detail.component";
import { OrderDetailComponent } from "./preliminaries/order-detail/order-detail/order-detail.component";
import { RegisterOrderDetailComponent } from "./preliminaries/order-detail/register-order-detail/register-order-detail.component";
import { UpdateCompromiseDateComponent } from "./preliminaries/order-detail/update-compromise-date/update-compromise-date.component";
import { OrderFromQuotationStepperComponent } from "./preliminaries/order-from-quotation/order-from-quotation-stepper/order-from-quotation-stepper.component";
import { OrderPriceComponent } from "./preliminaries/order-price/order-price/order-price.component";
import { AnnulOrderComponent } from "./preliminaries/order/annul-order/annul-order.component";
import { ImportOrdersComponent } from "./preliminaries/order/import-orders/import-orders.component";
import { OrderComponent } from "./preliminaries/order/order/order.component";
import { OrdersConsultationComponent } from "./preliminaries/order/orders-consultation/orders-consultation.component";
import { PrintOrderComponent } from "./preliminaries/order/print-order/print-order.component";
import { RegisterOrderComponent } from "./preliminaries/order/register-order/register-order.component";
import { PendingOrderComponent } from "./preliminaries/preliminaries-report/pending-order/pending-order.component";
import { PurchaseProjectionComponent } from "./preliminaries/purchase-projection/purchase-projection/purchase-projection.component";
import { RegisterPurchaseProjectionComponent } from "./preliminaries/purchase-projection/register-purchase-projection/register-purchase-projection.component";
import { AttachImagesQuotationDetailComponent } from './preliminaries/quotation-detail/attach-images-quotation-detail/attach-images-quotation-detail.component';
import { CopyQuotationComponent } from "./preliminaries/quotation-detail/copy-quotation/copy-quotation.component";
import { DetailFromCompositeArticleComponent } from "./preliminaries/quotation-detail/detail-from-composite-article/detail-from-composite-article.component";
import { DetailFromSolutionComponent } from "./preliminaries/quotation-detail/detail-from-solution/detail-from-solution.component";
import { NewRegisterQuotationDetailComponent } from "./preliminaries/quotation-detail/new-register-quotation-detail/new-register-quotation-detail.component";
import { QuotationDetailComponent } from "./preliminaries/quotation-detail/quotation-detail/quotation-detail.component";
import { RegisterQuotationDetailComponent } from "./preliminaries/quotation-detail/register-quotation-detail/register-quotation-detail.component";
import { PrintVersionComponent } from "./preliminaries/quotation-version/print-version/print-version.component";
import { RegisterQuotationVersionComponent } from "./preliminaries/quotation-version/register-quotation-version/register-quotation-version.component";
import { ImplementQuotationComponent } from "./preliminaries/quotation/implement-quotation/implement-quotation.component";
import { ImportQuotationsComponent } from "./preliminaries/quotation/import-quotations/import-quotations.component";
import { PrintQuotationComponent } from "./preliminaries/quotation/print-quotation/print-quotation.component";
import { QuotationComponent } from "./preliminaries/quotation/quotation/quotation.component";
import { RegisterQuotationModalComponent } from "./preliminaries/quotation/register-quotation-modal/register-quotation-modal.component";
import { RegisterQuotationComponent } from "./preliminaries/quotation/register-quotation/register-quotation.component";
import { RejectQuotationComponent } from "./preliminaries/quotation/reject-quotation/reject-quotation.component";
import { RevertImportQuotationsComponent } from "./preliminaries/quotation/revert-import-quotations/revert-import-quotations.component";
import { CancelScheduledVisitComponent } from "./preliminaries/scheduled-visit/cancel-scheduled-visit/cancel-scheduled-visit.component";
import { RegisterScheduledVisitComponent } from "./preliminaries/scheduled-visit/register-scheduled-visit/register-scheduled-visit.component";
import { ScheduledVisitComponent } from "./preliminaries/scheduled-visit/scheduled-visit/scheduled-visit.component";
import { DeactivateConstructionSiteErrorsModalComponent } from "./rental/deactivate-construction-site/deactivate-construction-site-errors-modal/deactivate-construction-site-errors-modal.component";
import { DeactivateConstructionSiteComponent } from "./rental/deactivate-construction-site/deactivate-construction-site/deactivate-construction-site.component";
import { DevolutionDetailComponent } from "./rental/devolution-detail/devolution-detail/devolution-detail.component";
import { RegisterDevolutionDetailComponent } from "./rental/devolution-detail/register-devolution-detail/register-devolution-detail.component";
import { DevolutionComponent } from "./rental/devolution/devolution/devolution.component";
import { PrintDevolutionComponent } from "./rental/devolution/print-devolution/print-devolution.component";
import { PrintPredevolutionModalComponent } from "./rental/devolution/print-predevolution-modal/print-predevolution-modal.component";
import { PrintPredevolutionComponent } from "./rental/devolution/print-predevolution/print-predevolution.component";
import { RegisterDevolutionComponent } from "./rental/devolution/register-devolution/register-devolution.component";
import { OrderAdjustmentDetailComponent } from "./rental/order-adjustment-detail/order-adjustment-detail/order-adjustment-detail.component";
import { RegisterOrderAdjustmentDetailComponent } from "./rental/order-adjustment-detail/register-order-adjustment-detail/register-order-adjustment-detail.component";
import { RegisterOrderAdjustmentComponent } from "./rental/order-adjustment/register-order-adjustment/register-order-adjustment.component";
import { ManualOrderComponent } from "./rental/remission-detail/manual-order/manual-order.component";
import { MassiveOrderComponent } from "./rental/remission-detail/massive-order/massive-order/massive-order.component";
import { OrderDataComponent } from "./rental/remission-detail/order-data/order-data.component";
import { RegisterManualOrderComponent } from "./rental/remission-detail/register-manual-order/register-manual-order.component";
import { RegisterRemissionDetailComponent } from "./rental/remission-detail/register-remission-detail/register-remission-detail.component";
import { RemissionDetailHoursDaysComponent } from "./rental/remission-detail/remission-detail-hours-days/remission-detail-hours-days.component";
import { RemissionDetailComponent } from "./rental/remission-detail/remission-detail/remission-detail.component";
import { PrintRemissionComponent } from "./rental/remission/print-remission/print-remission.component";
import { RegisterRemissionComponent } from "./rental/remission/register-remission/register-remission.component";
import { RemissionComponent } from "./rental/remission/remission/remission.component";
import { ImportRentalBalanceComponent } from "./rental/rental-balance/import-rental-balance/import-rental-balance.component";
import { RentalMovementImportComponent } from "./rental/rental-balance/rental-movement-import/rental-movement-import.component";
import { ReverseRentalBalanceComponent } from "./rental/rental-balance/reverse-rental-balance/reverse-rental-balance.component";
import { RegisterRentalPeriodComponent } from "./rental/rental-period/register-rental-period/register-rental-period.component";
import { RentalPeriodComponent } from "./rental/rental-period/rental-period/rental-period.component";
import { BalancesClientCostcenterComponent } from "./rental/rental-report/balances-client-costcenter/balances-client-costcenter.component";
import { BalancesShopComponent } from "./rental/rental-report/balances-shop/balances-shop.component";
import { BalancesWorkshopComponent } from "./rental/rental-report/balances-workshop/balances-workshop.component";
import { ClientDistributionComponent } from "./rental/rental-report/client-distribution/client-distribution.component";
import { ConstructionWithoutEquipmentComponent } from "./rental/rental-report/construction-without-equipment/construction-without-equipment.component";
import { CostCenterDiscountsComponent } from "./rental/rental-report/cost-center-discounts/cost-center-discounts.component";
import { CostCenterDistributionComponent } from "./rental/rental-report/cost-center-distribution/cost-center-distribution.component";
import { DaysConstructionSiteComponent } from "./rental/rental-report/days-construction-site/days-construction-site.component";
import { HistoricalMovementCostCenterComponent } from "./rental/rental-report/historical-movement-cost-center/historical-movement-cost-center.component";
import { HistoricalMovementShopComponent } from "./rental/rental-report/historical-movement-shop/historical-movement-shop.component";
import { HistoricalMovementWorkshopComponent } from "./rental/rental-report/historical-movement-workshop/historical-movement-workshop.component";
import { InvoicedReplacementComponent } from "./rental/rental-report/invoiced-replacement/invoiced-replacement.component";
import { MovementsKilogramsComponent } from "./rental/rental-report/movements-kilograms/movements-kilograms.component";
import { OccupancyPercentageComponent } from "./rental/rental-report/occupancy-percentage/occupancy-percentage.component";
import { ReportReplacementComponent } from "./rental/rental-report/report-replacement/report-replacement.component";
import { SummaryBalancesComponent } from "./rental/rental-report/summary-balances/summary-balances.component";
import { TotalDistributionComponent } from "./rental/rental-report/total-distribution/total-distribution.component";
import { TransportComponent } from "./rental/rental-report/transport/transport.component";
import { RegisterServiceDetailComponent } from "./rental/service-detail/register-service-detail/register-service-detail.component";
import { ServiceDetailComponent } from "./rental/service-detail/service-detail/service-detail.component";
import { ServiceManualOrderComponent } from "./rental/service-detail/service-manual-order/service-manual-order.component";
import { PrintServiceComponent } from "./rental/service/print-service/print-service.component";
import { RegisterServiceComponent } from "./rental/service/register-service/register-service.component";
import { ServiceComponent } from "./rental/service/service/service.component";
import { RegisterSuspensionDetailComponent } from "./rental/suspension-detail/register-suspension-detail/register-suspension-detail.component";
import { SuspensionDetailComponent } from "./rental/suspension-detail/suspension-detail/suspension-detail.component";
import { PrintSuspensionComponent } from "./rental/suspension/print-suspension/print-suspension.component";
import { RegisterSuspensionComponent } from "./rental/suspension/register-suspension/register-suspension.component";
import { SuspensionComponent } from "./rental/suspension/suspension/suspension.component";
import { RegisterTransferConstructionSiteDetailComponent } from './rental/transfer-construction-site-detail/register-transfer-construction-site-detail/register-transfer-construction-site-detail.component';
import { TransferConstructionSiteDetailComponent } from './rental/transfer-construction-site-detail/transfer-construction-site-detail/transfer-construction-site-detail.component';
import { PrintTransferConstructionSiteComponent } from "./rental/transfer-construction-site/print-transfer-construction-site/print-transfer-construction-site.component";
import { RegisterTransferConstructionSiteComponent } from './rental/transfer-construction-site/register-transfer-construction-site/register-transfer-construction-site.component';
import { TransferConstructionSiteComponent } from './rental/transfer-construction-site/transfer-construction-site/transfer-construction-site.component';
import { ConsolidatedPendingsOrdersComponent } from "./shopping/consolidated-pendings-orders/consolidated-pendings-orders/consolidated-pendings-orders.component";
import { DocumentSupportDetailComponent } from "./shopping/document-support-detail/document-support-detail/document-support-detail.component";
import { RegisterDocumentSupportDetailComponent } from "./shopping/document-support-detail/register-document-support-detail/register-document-support-detail.component";
import { CopyDocumentSupportComponent } from "./shopping/document-support/copy-document-support/copy-document-support.component";
import { DocumentSupportImportComponent } from "./shopping/document-support/document-support-import/document-support-import.component";
import { DocumentSupportComponent } from "./shopping/document-support/document-support/document-support.component";
import { PrintDocumentSupportComponent } from "./shopping/document-support/print-document-support/print-document-support.component";
import { RegisterDocumentSupportComponent } from "./shopping/document-support/register-document-support/register-document-support.component";
import { InternalOrderDetailComponent } from "./shopping/internal-order-detail/internal-order-detail/internal-order-detail.component";
import { RegisterInternalOrderDetailComponent } from "./shopping/internal-order-detail/register-internal-order-detail/register-internal-order-detail.component";
import { InternalOrderFromQuotationComponent } from "./shopping/internal-order-from-quotation/internal-order-from-quotation.component";
import { InternalOrderImportComponent } from "./shopping/internal-order/internal-order-import/internal-order-import.component";
import { InternalOrderComponent } from "./shopping/internal-order/internal-order/internal-order.component";
import { PrintInternalOrderComponent } from "./shopping/internal-order/print-internal-order/print-internal-order.component";
import { RegisterInternalOrderComponent } from "./shopping/internal-order/register-internal-order/register-internal-order.component";
import { ProviderInvoiceDetailComponent } from "./shopping/provider-invoice-detail/provider-invoice-detail/provider-invoice-detail.component";
import { RegisterProviderInvoiceDetailComponent } from "./shopping/provider-invoice-detail/register-provider-invoice-detail/register-provider-invoice-detail.component";
import { ListProviderInvoiceRetentionComponent } from "./shopping/provider-invoice-retention/list-provider-invoice-retention/list-provider-invoice-retention.component";
import { PrefixInvoiceNumberComponent } from "./shopping/provider-invoice/prefix-invoice-number/prefix-invoice-number.component";
import { ProviderInvoiceComponent } from "./shopping/provider-invoice/provider-invoice/provider-invoice.component";
import { RegisterProviderInvoiceComponent } from "./shopping/provider-invoice/register-provider-invoice/register-provider-invoice.component";
import { ProviderNoteDetailComponent } from "./shopping/provider-note-detail/provider-note-detail/provider-note-detail.component";
import { RegisterProviderNoteDetailComponent } from "./shopping/provider-note-detail/register-provider-note-detail/register-provider-note-detail.component";
import { ListProviderNoteRetentionComponent } from "./shopping/provider-note-retention/list-provider-note-retention/list-provider-note-retention.component";
import { PrefixNoteNumberComponent } from "./shopping/provider-note/prefix-note-number/prefix-note-number.component";
import { ProviderNoteComponent } from "./shopping/provider-note/provider-note/provider-note.component";
import { RegisterProviderNoteComponent } from "./shopping/provider-note/register-provider-note/register-provider-note.component";
import { PurchaseOrderDetailComponent } from "./shopping/purchase-order-detail/purchase-order-detail/purchase-order-detail.component";
import { RegisterPurchaseOrderDetailComponent } from "./shopping/purchase-order-detail/register-purchase-order-detail/register-purchase-order-detail.component";
import { PrintPurchaseOrderComponent } from "./shopping/purchase-order/print-purchase-order/print-purchase-order.component";
import { PurchaseOrderImportComponent } from "./shopping/purchase-order/purchase-order-import/purchase-order-import.component";
import { PurchaseOrderComponent } from "./shopping/purchase-order/purchase-order/purchase-order.component";
import { RegisterPurchaseOrderComponent } from "./shopping/purchase-order/register-purchase-order/register-purchase-order.component";
import { ImportStorePriceComponent } from "./subrental/store-price/import-store-price/import-store-price.component";
import { RegisterStorePriceComponent } from "./subrental/store-price/register-store-price/register-store-price.component";
import { StorePriceComponent } from "./subrental/store-price/store-price/store-price.component";
import { SubrentalCutoffDetailComponent } from "./subrental/subrental-cutoff-detail/subrental-cutoff-detail.component";
import { LiquidationComponent } from "./subrental/subrental-cutoff/liquidation/liquidation.component";
import { PreviewLiquidationComponent } from "./subrental/subrental-cutoff/preview-liquidation/preview-liquidation.component";
import { RegisterSubrentalCutoffComponent } from "./subrental/subrental-cutoff/register-subrental-cutoff/register-subrental-cutoff.component";
import { SubrentalCutoffComponent } from "./subrental/subrental-cutoff/subrental-cutoff/subrental-cutoff.component";
import { RegisterSubrentalEntryDetailComponent } from "./subrental/subrental-entry-detail/register-subrental-entry-detail/register-subrental-entry-detail.component";
import { SubrentalEntryDetailComponent } from "./subrental/subrental-entry-detail/subrental-entry-detail/subrental-entry-detail.component";
import { ImportSubrentalEntryComponent } from "./subrental/subrental-entry/import-subrental-entry/import-subrental-entry.component";
import { PrintSubrentalEntryComponent } from "./subrental/subrental-entry/print-subrental-entry/print-subrental-entry.component";
import { RegisterSubrentalEntryComponent } from "./subrental/subrental-entry/register-subrental-entry/register-subrental-entry.component";
import { SubrentalEntryComponent } from "./subrental/subrental-entry/subrental-entry/subrental-entry.component";
import { RegisterSubrentalOutputDetailComponent } from "./subrental/subrental-output-detail/register-subrental-output-detail/register-subrental-output-detail.component";
import { SubrentalOutputDetailComponent } from "./subrental/subrental-output-detail/subrental-output-detail/subrental-output-detail.component";
import { PrintSubrentalOutputComponent } from "./subrental/subrental-output/print-subrental-output/print-subrental-output.component";
import { RegisterSubrentalOutputComponent } from "./subrental/subrental-output/register-subrental-output/register-subrental-output.component";
import { SubrentalOutputComponent } from "./subrental/subrental-output/subrental-output/subrental-output.component";
import { ItemPreinvoicedValueComponent } from "./subrental/subrental-report/item-preinvoiced-value/item-preinvoiced-value.component";
import { ItemUtilityComponent } from "./subrental/subrental-report/item-utility/item-utility.component";
import { CloseConcurrenceComponent } from "./utilities/concurrence/close-concurrence/close-concurrence.component";
import { LogsComponent } from "./utilities/logs/logs.component";
import { SynchronizeInventoryMovementComponent } from "./utilities/synchronize-siesa/synchronize-inventory-movement/synchronize-inventory-movement.component";
import { ViewPrimengModule } from './view-primeng.module';
import { ViewRoutingModule } from "./view-routing.module";
import { AdvancePaymentsAppliedComponent } from "./wallet/advance-payments-applied/advance-payments-applied/advance-payments-applied.component";
import { CashReceiptPaymentComponent } from "./wallet/cash-receipt-payment/cash-receipt-payment/cash-receipt-payment.component";
import { CashReceiptImportComponent } from "./wallet/cash-receipt/cash-receipt-import/cash-receipt-import.component";
import { CashReceiptPrintingRangeComponent } from "./wallet/cash-receipt/cash-receipt-printing-range/cash-receipt-printing-range.component";
import { CashReceiptComponent } from "./wallet/cash-receipt/cash-receipt/cash-receipt.component";
import { InvoiceCashReceiptRetentionImportComponent } from "./wallet/cash-receipt/invoice-cash-receipt-retention-import/invoice-cash-receipt-retention-import.component";
import { PrintCashReceiptComponent } from "./wallet/cash-receipt/print-cash-receipt/print-cash-receipt.component";
import { RegisterCashReceiptComponent } from "./wallet/cash-receipt/register-cash-receipt/register-cash-receipt.component";
import { WayToPayImportComponent } from "./wallet/cash-receipt/way-to-pay-import/way-to-pay-import.component";
import { IncomeConceptComponent } from "./wallet/income-concept/income-concept/income-concept.component";
import { RegisterIncomeConceptComponent } from "./wallet/income-concept/register-income-concept/register-income-concept.component";
import { InvoiceCashReceiptRetentionModalComponent } from "./wallet/invoice-cash-receipt-retention/invoice-cash-receipt-retention-modal/invoice-cash-receipt-retention-modal.component";
import { InvoiceCashReceiptComponent } from "./wallet/invoice-cash-receipt/invoice-cash-receipt/invoice-cash-receipt.component";
import { RegisterInvoiceCashReceiptComponent } from "./wallet/invoice-cash-receipt/register-invoice-cash-receipt/register-invoice-cash-receipt.component";
import { ProcessWalletBalanceComponent } from "./wallet/wallet-balance/process-wallet-balance/process-wallet-balance.component";
import { RegisterWalletManagementComponent } from "./wallet/wallet-management/register-wallet-management/register-wallet-management.component";
import { WalletManagementComponent } from "./wallet/wallet-management/wallet-management/wallet-management.component";
import { CollectionBySellerComponent } from "./wallet/wallet-report/collection-by-seller/collection-by-seller.component";
import { DetailedAccountStatementComponent } from "./wallet/wallet-report/detailed-account-statement/detailed-account-statement.component";
import { GeneratedReceiptsComponent } from "./wallet/wallet-report/generated-receipts/generated-receipts.component";
import { PaymentsByClientComponent } from "./wallet/wallet-report/payments-by-client/payments-by-client.component";
import { SummaryAccountStatementComponent } from "./wallet/wallet-report/summary-account-statement/summary-account-statement.component";
import { TotalIncomePerMonthComponent } from "./wallet/wallet-report/total-income-per-month/total-income-per-month.component";
import { WalletBalanceComponent } from "./wallet/wallet-report/wallet-balance/wallet-balance.component";
import { WalletComponent } from "./wallet/wallet-report/wallet/wallet.component";

@NgModule({
  declarations: [
    //Components Accounting Interface
    AccountingInterfaceComponent,
    RegisterAccountingInterfaceComponent,

    //Components Accounting Model
    AccountingModelComponent,
    AccountingModelDetailComponent,
    AssignFamiliesComponent,
    ConceptFamilyForAccountingModelComponent,
    ConceptInvoicingForAccountingModelComponent,
    RegisterAccountingModelComponent,
    RegisterAccountingModelDetailComponent,
    ConceptInvoicingForAccountingModelComponent,

    //Components Accounting Interface Detail
    AccountingInterfaceDetailComponent,
    AccountingInterfacePreviewComponent,
    SynchronizerAccountingInterfaceComponent,

    //Components Advance Invoice
    AdvanceInvoiceComponent,
    AdvanceInvoiceConceptComponent,
    RegisterAdvanceInvoiceComponent,
    RegisterAdvanceInvoiceConceptComponent,

    //Components Advance Payments
    AdvancePaymentsAppliedComponent,

    //Components Article
    ArticleComponent,
    AttachImagesArticleComponent,
    EquipmentLogbookComponent,
    ImportArticleComponent,
    PrintEquipmentLogbookSimpleComponent,
    PrintEquipmentLogbookValuedComponent,
    RegisterArticleComponent,
    ImportEquipmentLogbookComponent,

    //Components Article Generic
    RegisterArticleGenericComponent,
    ArticleGenericComponent,

    //Component Article Task
    ArticleTaskComponent,
    RegisterArticleTaskComponent,
    PendingArticleTaskComponent,


    //Component Audit
    AuditComponent,

    //Components Branch
    RegisterBranchComponent,
    AdvancedOptionsBranchComponent,
    BranchComponent,

    //Components Breakdown
    BreakdownComponent,
    RegisterBreakdownComponent,
    ImportBreakdownComponent,
    DistributeTotalValueBreakdownComponent,
    ApplyDiscountBreakdownComponent,

    //Components Bussiness Documents Type
    RegisterBussinessDocumentsTypeComponent,
    BussinessDocumentsTypeComponent,

    //Components Bussiness Documents Resolution
    RegisterBussinessDocumentsResolutionComponent,
    BussinessDocumentsResolutionComponent,

    //Components Cash Receipt
    CashReceiptComponent,
    CashReceiptImportComponent,
    WayToPayImportComponent,
    RegisterCashReceiptComponent,
    InvoiceCashReceiptRetentionImportComponent,

    //Components Cash Receipt Payment
    CashReceiptPaymentComponent,
    CashReceiptPrintingRangeComponent,
    PrintCashReceiptComponent,

    //Components Charge Account
    ChargeAccountComponent,
    RegisterChargeAccountComponent,
    CopyChargeAccountComponent,
    ChargeAccountPrintingRangeComponent,
    AnnulChargeAccountComponent,
    PrintChargeAccountComponent,

    //Components Update CostCenter Price
    RegisterUpdateCostCenterPriceComponent,
    UpdateCostCenterPriceDetailComponent,

    //Components Charge Account Detail
    ChargeAccountDetailComponent,
    RegisterChargeAccountDetailComponent,

    //Components Charge Account Concept
    ListChargeAccountConceptComponent,

    //Components City
    CityComponent,
    RegisterCityComponent,

    //Components Client
    ClientComponent,
    ImportClientComponent,
    RegisterClientComponent,
    UpdateDocumentClientComponent,

    // Components Contact
    ContactReferenceModalComponent,

    //Components Composite Article
    CompositeArticleComponent,
    RegisterCompositeArticleComponent,
    CompositeArticleDetailComponent,
    RegisterCompositeArticleDetailComponent,
    ImportCompositeArticleComponent,

    //Components Company
    AdvancedOptionsCompanyComponent,
    CompanyComponent,
    GeneralParameterComponent,
    PermissionsCompanyComponent,
    RegisterCompanyComponent,
    DeleteCompanyComponent,
    MandatorComponent,

    //Components CompanyCity
    CompanyCityComponent,
    RegisterCompanyCityComponent,

    //Components Concept
    RegisterConceptComponent,
    ConceptComponent,

    //Components Concept Invoicing
    RegisterConceptInvoicingComponent,
    InvoicingModelComponent,
    RegisterInvoicingModelComponent,
    InvoicingModelDetailComponent,
    RegisterInvoicingModelDetailComponent,
    ImportInvoicingModelDetailComponent,
    CopyInvoicingModelComponent,
    ConceptInvoicingComponent,
    ImportConceptInvoicingComponent,

    //Components Concurrence
    CloseConcurrenceComponent,

    //Components Consolidated Reservation
    ConsolidatedReservationComponent,

    //Components ConstructionSite
    RegisterConstructionSiteComponent,
    ImportConstructionSiteComponent,
    ConstructionSiteComponent,

    //Components Cost Adjustment
    CostAdjustmentComponent,
    CostAdjustmentDetailComponent,
    RegisterCostAdjustmentComponent,
    RegisterCostAdjustmentDetailComponent,
    PrintCostAdjustmentComponent,

    //Components CostCenter
    ImportCostCenterComponent,
    CostCenterComponent,
    RegisterCostCenterComponent,

    //Components CostCenter Price
    CostCenterPriceComponent,
    ImportCostCenterPriceComponent,
    RegisterCostCenterPriceComponent,

    //Components CostCenterUser
    CostCenterUserComponent,

    //Components Currency
    RegisterCurrencyComponent,
    CurrencyComponent,

    //Components Currency Exchange
    RegisterCurrencyExchangeComponent,
    CurrencyExchangeComponent,

    //Components Department
    DepartmentComponent,
    RegisterDepartmentComponent,

    //Components Devolution
    DevolutionComponent,
    RegisterDevolutionComponent,
    PrintDevolutionComponent,
    DevolutionDetailComponent,
    PrintPredevolutionComponent,
    PrintPredevolutionModalComponent,
    RegisterDevolutionDetailComponent,

    //Components Devolution Projection
    DevolutionProjectionComponent,
    RegisterDevolutionProjectionComponent,
    DevolutionProjectionDetailComponent,
    RegisterDevolutionProjectionDetailComponent,


    //Components DocumentSupport
    CopyDocumentSupportComponent,
    DocumentSupportComponent,
    RegisterDocumentSupportComponent,
    PrintDocumentSupportComponent,
    DocumentSupportImportComponent,

    //Components DocumentSupportDetail
    DocumentSupportDetailComponent,
    RegisterDocumentSupportDetailComponent,

    //Components Electronic Invoice Interface
    ElectronicInvoiceInterfaceComponent,
    RegisterElectronicInvoiceInterfaceComponent,
    SynchronizerElectronicInvoiceInterfaceComponent,
    SendMailComponent,
    ElectronicInvoiceInterfaceDetailComponent,

    //Components Enterprise
    RegisterEnterpriseComponent,
    EnterpriseCityComponent,
    RegisterEnterpriseCityComponent,
    AttachImagesEnterpriseComponent,
    AdvancedOptionsEnterpriseComponent,
    EnterpriseComponent,

    //Components Family
    RegisterFamilyComponent,
    ImportFamilyComponent,
    FamilyComponent,

    //Components Formats
    FormatComponent,
    PreviewFormatComponent,
    RegisterFormatComponent,
    FormatDetailComponent,
    RegisterFormatDetailComponent,

    //Component Freight
    FreightModalComponent,
    RegisterFreightComponent,
    FreightComponent,

    //Components Group
    RegisterGroupComponent,
    ImportGroupComponent,
    GroupComponent,

    //Components ICA Rate
    RegisterIcaRateComponent,
    IcaRateComponent,
    ImportIcaRateComponent,

    //Components Income Concept
    RegisterIncomeConceptComponent,
    IncomeConceptComponent,

    //Components InternalOrder
    InternalOrderComponent,
    RegisterInternalOrderComponent,
    PrintInternalOrderComponent,
    InternalOrderImportComponent,

    //Components InternalOrder Detail
    InternalOrderDetailComponent,
    RegisterInternalOrderDetailComponent,

    //Components Inventory
    RegisterInventoryComponent,
    InventoryComponent,
    InventoryBalancesImportComponent,
    ReverseInventoryBalancesComponent,

    //Components InventoryUser
    InventoryUserComponent,

    //Components InventoryClass
    InventoryClassComponent,
    RegisterInventoryClassComponent,

    //Components InventoryEntry
    RegisterInventoryEntryComponent,
    RegisterInventoryEntryDetailComponent,
    InventoryEntryDetailComponent,
    InventoryEntryComponent,
    PrintInventoryEntryComponent,
    ImportInventoryEntryComponent,

    //Components InventoryOutput
    InventoryOutputComponent,
    InventoryOutputDetailComponent,
    PrintInventoryOutputComponent,
    RegisterInventoryOutputComponent,
    RegisterInventoryOutputDetailComponent,

    //Components InventoryPeriod
    RegisterInventoryPeriodComponent,
    InventoryPeriodComponent,

    //Components InventoryReport
    BranchAverageCostComponent,
    EntryShopComponent,
    KardexArticleComponent,
    OutputShopComponent,
    TypeDetailedValuesComponent,
    TypeSummaryValuesComponent,
    StockMaxComponent,
    StockMinComponent,
    TypeQuantitiesComponent,
    SummaryInventoryMovementComponent,

    //Components InventoryTransfer
    InventoryTransferComponent,
    RegisterInventoryTransferComponent,
    InventoryTransferDetailComponent,
    RegisterInventoryTransferDetailComponent,
    PrintInventoryTransferComponent,

    //Components Sinchronize Siesa
    SynchronizeInventoryMovementComponent,


    //Components Invoice
    InvoiceComponent,
    RegisterInvoiceComponent,
    CopyInvoiceComponent,
    ListInvoiceAttachmentsComponent,
    PrintInvoiceComponent,
    InvoicePrintingRangeComponent,
    InvoicesImportComponent,
    InfoInvoiceComponent,
    PreInvoiceComponent,
    SettlementComponent,

    //Components Invoice Cash Receipt
    InvoiceCashReceiptComponent,
    RegisterInvoiceCashReceiptComponent,

    //Components Invoice Cash Receipt Retention
    InvoiceCashReceiptRetentionModalComponent,

    //Components Invoice Detail
    RegisterInvoiceDetailComponent,
    InvoiceDetailComponent,

    //Components Invoice Concept
    ListInvoiceConceptComponent,

    //Components Invoicing Cutoff
    InvoicingCutoffComponent,
    RegisterInvoicingCutoffComponent,
    PreInvoicingComponent,
    PreviewPreInvoicingComponent,
    InvoiceInvoicingCutoffComponent,
    InvoicingCutoffDetailComponent,

    //Components Invoicing Report
    DailyReportVoucherComponent,
    InvoicesByConceptComponent,
    InvoicesGeneratedComponent,
    InvoicingClientComponent,
    InvoicingClientConstructionSiteComponent,
    InvoicingClientCostCenterGroupComponent,
    DiscountsTopThirtyPercentComponent,
    DiscountsLowerHundredPercentComponent,
    IncomeCostcenterEquipmentComponent,
    IncomeReportComponent,
    InvoicingConceptComponent,
    InvoicingConceptSellerComponent,
    InvoicingCostCenterComponent,
    InvoicingFamilyComponent,
    InvoicingKilogramsComponent,
    InvoicingAddressReportComponent,
    ItemRevenueComponent,
    ItemRevenueStoreComponent,
    PendingInvoiceComponent,
    TaxReportComponent,
    TotalMonthComponent,
    InvoicingSellerConceptComponent,
    InvoicingSellerKilogramsComponent,
    InvoicingBusinessTypeComponent,
    PreInvoicingItemRevenueComponent,
    BalancesCostCenterComponent,

    //Component Main
    MainComponent,

    //Component Master solution
    MasterSolutionComponent,
    RegisterMasterSolutionComponent,
    RegisterMasterSolutionDetailComponent,
    ImportMasterSolutionDetailComponent,
    MasterSolutionDetailComponent,

    //Components Maintenance
    ImportTransferStoreWorkshopDetailComponent,
    ListWorkshopEquipmentComponent,
    MaintenanceOrderComponent,
    MaintenanceOrderImportComponent,
    MaintenanceStrategyComponent,
    MaintenanceStrategyImportComponent,
    NoteStageModalComponent,
    PrintMaintenanceOrderSiteComponent,
    PrintMaintenanceOrderWorkshopComponent,
    PrintMaintenanceOrderScheduledComponent,
    PrintTransferStoreWorkshopComponent,
    PrintTransferWorkshopStoreComponent,
    RegisterMaintenanceOrderComponent,
    RegisterTransferStoreWorkshopComponent,
    RegisterTransferStoreWorkshopDetailComponent,
    RegisterTransferWorkshopStoreComponent,
    RegisterTransferWorkshopStoreDetailComponent,
    TransferStoreWorkshopComponent,
    TransferWorkshopStoreComponent,
    TransferStoreWorkshopDetailComponent,
    TransferWorkshopStoreDetailComponent,
    MaintenanceOrderActivitiesComponent,
    MaintenanceOrderSuppliesComponent,
    RegisterMaintenanceOrderSuppliesComponent,
    StoreBalancesImportComponent,

    //Components maintenance report
    ProgrammingDaysComponent,
    MaintenanceCostsForEquipmentComponent,
    RepairHistoryComponent,
    EquipmentLogbookReportComponent,

    //Components Maintenance Activities
    MaintenanceActivitiesComponent,
    RegisterMaintenanceActivitiesComponent,
    ImportMaintenanceActivitiesComponent,

    //Components Maintenance Component
    ComponentComponent,
    RegisterComponentComponent,

    //Components Maintenance Element
    ElementComponent,
    RegisterElementComponent,

    //Components Maintenance Routine
    CopyMaintenanceRoutineComponent,
    MaintenanceRoutineComponent,
    PrintMaintenanceRoutineComponent,
    RegisterMaintenanceRoutineComponent,
    MaintenanceRoutineImportComponent,

    //Components Maintenance Routine Detail
    MaintenanceRoutineDetailComponent,
    RegisterMaintenanceRoutineDetailComponent,

    //Components Maintenance  Scheduling
    MaintenanceSchedulingComponent,
    RegisterMaintenanceSchedulingComponent,
    MaintenanceSchedulingDetailComponent,
    ProcessMaintenanceSchedulingComponent,
    GenerateMaintenanceOrdersComponent,
    //Components Maintenance Routine Supply
    MaintenanceRoutineSupplyComponent,
    RegisterMaintenanceRoutineSupplyComponent,
    MaintenanceRoutineSupplyImportComponent,

    //Component Mechanic
    RegisterMechanicComponent,
    UpdateDocumentMechanicComponent,
    ImportMechanicComponent,
    MechanicComponent,

    //Components Meter
    MeterComponent,
    RegisterMeterComponent,
    MeterDetailComponent,
    RegisterMeterDetailComponent,

    //Components Navigate
    NavigationComponent,

    //Components Note
    NoteComponent,
    RegisterNoteComponent,
    PrintNoteComponent,
    NotesImportComponent,

    //Components Note Detail
    NoteDetailComponent,
    RegisterNoteDetailArticleComponent,
    RegisterNoteDetailConceptComponent,

    //Componets Order
    OrderComponent,
    RegisterOrderComponent,
    AnnulOrderComponent,
    PrintOrderComponent,
    OrderDetailComponent,
    ImportOrdersComponent,
    OrdersConsultationComponent,

    //Componets Order Detail
    RegisterOrderDetailComponent,
    ImportOrderDetailComponent,
    UpdateCompromiseDateComponent,

    //Componets Equipment Availability
    EquipmentAvailabilityComponent,

    //Componets Consolidated Equipment Availability
    ConsolidatedEquipmentAvailabilityComponent,
    ConsolidatedAvailabilityReportComponent,

    //Componet Order Adjustment
    RegisterOrderAdjustmentComponent,
    OrderAdjustmentDetailComponent,
    RegisterOrderAdjustmentDetailComponent,

    //Componets Order price
    OrderPriceComponent,

    //Components Order From Quotation
    OrderFromQuotationStepperComponent,
    InternalOrderFromQuotationComponent,

    //Components PhysicalInventory
    AdjustExcessModalComponent,
    PhysicalInventoryComponent,
    PhysicalInventoryDetailComponent,
    PhysicalInventoryReportComponent,
    RegisterPhysicalInventoryComponent,
    RegisterPhysicalInventoryDetailComponent,

    //Pipes
    FormatLabelPipe,
    GroupInfoPipe,
    MonthPipe,
    UserPipe,

    //Components Pendings Orders
    ConsolidatedPendingsOrdersComponent,

    //Components Price List
    ImportPriceListComponent,
    ImportPriceListAsComponent,
    PriceListDetailComponent,
    PriceListComponent,
    RegisterPriceListDetailComponent,
    RegisterPriceListComponent,

    //Components ProfileUser
    ProfileUserComponent,
    RegisterProfileUserComponent,
    PermissionsProfileUserComponent,

    //Components Provider
    ImportProviderComponent,
    ProviderComponent,
    RegisterProviderComponent,
    UpdateDocumentProviderComponent,

    //Components Provider Invoice
    ListProviderInvoiceRetentionComponent,
    PrefixInvoiceNumberComponent,
    ProviderInvoiceComponent,
    RegisterProviderInvoiceComponent,

    //Components Provider Invoice Detail
    ProviderInvoiceDetailComponent,
    RegisterProviderInvoiceDetailComponent,

    //Components Provider Note
    PrefixNoteNumberComponent,
    ProviderNoteComponent,
    RegisterProviderNoteComponent,

    //Components Provider Note Detail
    ProviderNoteDetailComponent,
    RegisterProviderNoteDetailComponent,

    //Pipes Provider Note Retention
    ListProviderNoteRetentionComponent,

    //Components Purchase Order
    PurchaseOrderComponent,
    RegisterPurchaseOrderComponent,
    PurchaseOrderDetailComponent,
    RegisterPurchaseOrderDetailComponent,
    PrintPurchaseOrderComponent,
    PurchaseOrderImportComponent,

    //Components Purchase Projection
    PurchaseProjectionComponent,
    RegisterPurchaseProjectionComponent,

    //Componets Quotation
    QuotationComponent,
    RegisterQuotationComponent,
    RejectQuotationComponent,
    PrintQuotationComponent,
    ImplementQuotationComponent,
    ImportQuotationsComponent,
    RevertImportQuotationsComponent,

    //Componets Quotation Versión
    RegisterQuotationVersionComponent,
    PrintVersionComponent,

    //Componets Quotation Detail
    QuotationDetailComponent,
    RegisterQuotationDetailComponent,
    NewRegisterQuotationDetailComponent,
    RegisterQuotationModalComponent,
    DetailFromSolutionComponent,
    CopyQuotationComponent,
    AttachImagesQuotationDetailComponent,
    DetailFromCompositeArticleComponent,

    //Componets Transfer ConstructionSite
    TransferConstructionSiteComponent,
    RegisterTransferConstructionSiteComponent,
    TransferConstructionSiteDetailComponent,
    RegisterTransferConstructionSiteDetailComponent,
    PrintTransferConstructionSiteComponent,

    //Componets Deactivate ConstructionSites
    DeactivateConstructionSiteComponent,
    DeactivateConstructionSiteErrorsModalComponent,

    //Components Remission
    RegisterRemissionComponent,
    RemissionComponent,
    PrintRemissionComponent,
    RemissionDetailComponent,
    RegisterRemissionDetailComponent,
    RegisterManualOrderComponent,
    MassiveOrderComponent,
    ManualOrderComponent,
    OrderDataComponent,
    RemissionDetailHoursDaysComponent,

    //Components Rental Balance
    ImportRentalBalanceComponent,
    ReverseRentalBalanceComponent,
    RentalMovementImportComponent,

    //Components Rental Period
    RegisterRentalPeriodComponent,
    RentalPeriodComponent,

    //Components Rental Report
    BalancesClientCostcenterComponent,
    BalancesShopComponent,
    BalancesWorkshopComponent,
    ClientDistributionComponent,
    CostCenterDistributionComponent,
    DaysConstructionSiteComponent,
    MovementsKilogramsComponent,
    HistoricalMovementCostCenterComponent,
    HistoricalMovementShopComponent,
    CostCenterDiscountsComponent,
    HistoricalMovementWorkshopComponent,
    InvoicedReplacementComponent,
    OccupancyPercentageComponent,
    ReportReplacementComponent,
    SummaryBalancesComponent,
    TotalDistributionComponent,
    DaysConstructionSiteComponent,
    ConstructionWithoutEquipmentComponent,
    TransportComponent,

    //Components Repair
    RepairComponent,
    RepairModalComponent,
    RepairImportComponent,

    //Components Request Note
    PrintRequestNoteComponent,
    RequestNoteComponent,
    RegisterRequestNoteComponent,

    //Components Request Note Detail
    RequestNoteDetailComponent,

    //Component Sales Remission
    SalesRemissionComponent,
    RegisterSalesRemissionComponent,
    SalesRemissionDetailComponent,
    RegisterSalesRemissionDetailComponent,
    PrintSalesRemissionComponent,
    SalesRemissionManualOrderComponent,
    SalesRemissionMassiveOrderComponent,

    //Component Executed Visit
    CancelExecutedVisitComponent,
    ExecutedVisitComponent,
    PendingExecutedVisitComponent,
    RegisterExecutedVisitComponent,

    //Component Scheduled Visit
    CancelScheduledVisitComponent,
    RegisterScheduledVisitComponent,
    ScheduledVisitComponent,

    //Component Sector
    RegisterSectorComponent,
    SectorComponent,

    //Components Seller
    RegisterSellerComponent,
    UpdateDocumentSellerComponent,
    ImportSellerComponent,
    SellerComponent,

    //Components Service
    PrintServiceComponent,
    RegisterServiceComponent,
    RegisterServiceDetailComponent,
    ServiceComponent,
    ServiceDetailComponent,
    ServiceManualOrderComponent,

    //Components StockMaxMin
    StockMaxMinComponent,
    RegisterStockMaxMinComponent,
    ImportStockMaxMinComponent,

    //Components Store
    RegisterStoreComponent,
    ImportStoreComponent,
    StoreComponent,

    //Components Subgroup
    RegisterSubgroupComponent,
    ImportSubgroupComponent,
    SubgroupComponent,

    //Components Store Price
    ImportStorePriceComponent,
    RegisterStorePriceComponent,
    StorePriceComponent,

    //Components Subrental Cutoff
    LiquidationComponent,
    PreviewLiquidationComponent,
    RegisterSubrentalCutoffComponent,
    SubrentalCutoffComponent,
    SubrentalCutoffDetailComponent,

    //Components SubrentalEntry
    SubrentalEntryComponent,
    RegisterSubrentalEntryComponent,
    SubrentalEntryDetailComponent,
    RegisterSubrentalEntryDetailComponent,
    PrintSubrentalEntryComponent,
    ImportSubrentalEntryComponent,

    //Components SubrentalOutput
    SubrentalOutputComponent,
    RegisterSubrentalOutputComponent,
    SubrentalOutputDetailComponent,
    RegisterSubrentalOutputDetailComponent,
    PrintSubrentalOutputComponent,

    //Components Subrental Report
    ItemUtilityComponent,
    ItemPreinvoicedValueComponent,

    //Components Preliminaries Report
    PendingOrderComponent,

    //Components Suspension
    RegisterSuspensionComponent,
    PrintSuspensionComponent,
    SuspensionComponent,
    SuspensionDetailComponent,
    RegisterSuspensionDetailComponent,

    //Components Tax
    RegisterTaxComponent,
    TaxComponent,
    ImportTaxComponent,

    //Components Tax Type
    TaxTypeComponent,
    RegisterTaxTypeComponent,

    //Components Transactions
    TransactionsComponent,

    //Components Logs
    LogsComponent,

    //Components Transporter
    RegisterTransporterComponent,
    UpdateDocumentTransporterComponent,
    ImportTransporterComponent,
    TransporterComponent,

    //Components TransportInvoice
    RegisterTransportInvoiceComponent,
    TransportInvoiceComponent,

    //Components TransportInvoiceDetail
    RegisterTransportInvoiceDetailComponent,
    TransportInvoiceDetailComponent,

    //Components TypeConcept
    TypeConceptComponent,
    RegisterTypeConceptComponent,

    //Components TypeInventory
    TypeInventoryComponent,
    RegisterTypeInventoryComponent,

    //Components Unit
    RegisterUnitComponent,
    UnitComponent,

    //Components User
    UserComponent,
    RegisterUsersComponent,
    UpdatePasswordUserComponent,
    PermissionsUserComponent,

    //Components Vehicle
    RegisterVehicleComponent,
    ImportVehicleComponent,
    VehicleComponent,

    //Components WalletBalance
    ProcessWalletBalanceComponent,

    //Components WalletManagement
    RegisterWalletManagementComponent,
    WalletManagementComponent,

    //Components WalletReport
    CollectionBySellerComponent,
    DetailedAccountStatementComponent,
    GeneratedReceiptsComponent,
    PaymentsByClientComponent,
    SummaryAccountStatementComponent,
    TotalIncomePerMonthComponent,
    WalletComponent,
    WalletBalanceComponent,

    //Components WayToPay
    RegisterWayToPayComponent,
    WayToPayComponent,

    //Components Zone
    RegisterZoneComponent,
    ImportZoneComponent,
    ZoneComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    CustomIndicatorsComponent,
    CustomModalComponent,
    CustomTableComponent,
    CustomTablePrintComponent,
    CustomTableReportComponent,
    CustomTableReportPaymentsByClientComponent,
    CustomTableReportGeneratedReceiptsComponent,
    CustomAuditInfoComponent,
    CustomAutocompleteComponent,
    CustomButtonComponent,
    CustomCheckboxComponent,
    CustomChipComponent,
    CustomDatepickerComponent,
    CustomDatetimePickerComponent,
    CustomDatepickerReportComponent,
    CustomInputImageFileComponent,
    CustomInputNumberComponent,
    CustomInputDecimalComponent,
    CustomInputTextComponent,
    CustomInputgroupComponent,
    CustomInputPasswordComponent,
    CustomRadiobuttonComponent,
    CustomSelectComponent,
    CustomTagComponent,
    CustomTextareaComponent,
    SelectModule,
    AutoCompleteModule,
    AccordionModule,
    CustomProgressBarComponent,
    ViewPrimengModule,
    CommonModule,
    FormsModule,
    // QRCodeModule,
    QRCodeComponent,
    ReactiveFormsModule,
    MultiSelectModule,
    ToastrModule.forRoot(),
    ViewRoutingModule,
    StepperModule,
    CustomToggleSwitchComponent,
    CustomInitialConsecutiveComponent,
    DynamicFormatPipe,
    SkeletonModule,
    CustomTableReportEquipmentLogbookComponent
  ],
  providers: [
    DatePipe
  ],
  bootstrap: [],
  exports: []
})
export class ViewModule { }